import { DashSelfServeReconciliationMatchType } from "../../enums/dash-self-serve-reconciliation-match-type";

export interface IDashMatch {
    id: number,
    firstName: string,
    lastName: string,
    birthDate: string,
    transplantDate: string,
    donationType: number,
    donationTypeDescription: string,
    matchType: DashSelfServeReconciliationMatchType
}